<div class="gw-container">
    <form [formGroup]="destinatarioForm">

        <div class="gw-flex-titulos">
          <div>
           <h4>Destinatario</h4>
           <p class="gw-flex-titulo2">{{this.tipopaquete}}</p>
         </div>
          <div>
            <button class="gw-btn-backpantalla" (click)="limpiar()" type="button">Limpiar</button>
          </div>
        </div>

        <div class="checkbox-wrapper-4" style="margin-bottom: 20px;">
            <input class="inp-cbx" id="guardarDestinatariochkbox" type="checkbox" formControlName="guardarDestinatario">
            <label class="cbx" for="guardarDestinatariochkbox"><span>
                    <svg width="12px" height="10px">
                        <use xlink:href="#check-destinatario"></use>
                    </svg></span><span>Guardar en lista de destinatarios</span></label>
            <svg class="inline-svg">
                <symbol id="check-destinatario" viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                </symbol>
            </svg>
        </div>

        <div *ngIf="editingIddir" class="editing-banner">
            <span class="editing-text">
                <i class="fa-solid fa-pen-to-square"></i>
                Editando destinatario guardado
            </span>
            <button type="button" class="btn-cancel-edit" (click)="cancelarEdicion()">
                Cancelar Edición <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="div-form">
            <label class="lbl-text">Nombre</label>
            <div class="gw-flex-input-btn">
                <input class="doc-lbl" formControlName="nombre" id="nombred" maxlength="100" type="text" inputmode="text"
                    [ngClass]="{validacion: (Des.nombre.invalid || Des.nombre.hasError('IsEmpty')) && submitted}">
                <button type="button" class="gw-btn-orange-icon" (click)="abrirModalDirectorioDest()">
                    <i class="fa-solid fa-address-book"></i>
                    <span class="btn-text">Directorio</span>
                </button>
            </div>
            <div class="val-valido" [ngClass]="{invalido: (Des.nombre.invalid)  && submitted}">* Introduce el nombre
            </div>
        </div>

        <div class="gw-flex">
            <!-- <div class="gw-flex-l">
                <label class="lbl-text">País</label>
                <div class="select">
                    <select id="pais" formControlName="selectPais"
                        [ngClass]="{validacion: (Des.selectPais.invalid || Des.selectPais.hasError('isEmpty')) && submitted}"
                        required (change)="paisChanged($event.target.value)">
                        <option value="" disabled selected class="option s">Seleccione</option>
                        <option *ngFor="let i of pais" [value]="i.idpais">
                            {{ i.pais }}
                        </option>
                    </select>
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Des.selectPais.invalid)  && submitted}">* Introduce el país
                </div>
            </div> -->

            <div class="gw-flex-l">
                <label class="lbl-text">Estado</label>
                <div class="select">
                    <select id="pais" formControlName="selectEstado"
                        [ngClass]="{validacion: (Des.selectEstado.invalid || Des.selectEstado.hasError('isEmpty')) && submitted}"
                        required (change)="estadoChanged($event.target.value)">
                        <option value="" disabled selected class="option s">Seleccione</option>
                        <option *ngFor="let i of estado" [value]="i.idedo">
                            {{ i.estado }}
                        </option>
                    </select>
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Des.selectEstado.invalid)  && submitted}">* Introduce el estado
                </div>
            </div>

            <div class="gw-flex-r">
              <label class="lbl-text">Ciudad</label>
              <div class="select">
                  <select id="pais" formControlName="selectCiudad"
                      [ngClass]="{validacion: (Des.selectCiudad.invalid || Des.selectCiudad.hasError('isEmpty')) && submitted}"
                      required (change)="ciudadChanged($event.target.value)">
                      <option value="" disabled selected class="option s">Seleccione</option>
                      <option *ngFor="let i of ciudad" [value]="i.idcd">
                          {{ i.ciudad }}
                      </option>
                  </select>
              </div>
              <div class="val-valido" [ngClass]="{invalido: (Des.selectCiudad.invalid)  && submitted}">* Introduce la ciudad
              </div>
          </div>
        </div>

        <div class="gw-flex">
            <!-- <div class="gw-flex-l">
                <label class="lbl-text">Ciudad</label>
                <div class="select">
                    <select id="pais" formControlName="selectCiudad"
                        [ngClass]="{validacion: (Des.selectCiudad.invalid || Des.selectCiudad.hasError('isEmpty')) && submitted}"
                        required (change)="ciudadChanged($event.target.value)">
                        <option value="" disabled selected class="option s">Seleccione</option>
                        <option *ngFor="let i of ciudad" [value]="i.idcd">
                            {{ i.ciudad }}
                        </option>
                    </select>
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Des.selectCiudad.invalid)  && submitted}">* Introduce la ciudad
                </div>
            </div> -->

            <label class="lbl-text" style="position:absolute">Entrega</label>
            <div class="gw-flex-l" style="display: flex; align-items: center; padding-top: 12px">
              <div class="checkbox-wrapper-4">
                <input class="inp-cbx" id="sucursalchkbox" type="checkbox" formControlName="sucursalSeleccionado" (click)="imprimirEstadoCheckboxes('sucursalSeleccionado')">
                <label class="cbx" for="sucursalchkbox"><span>
                <svg width="12px" height="10px">

                </svg></span><span>Sucursal</span></label>
                <svg class="inline-svg">
                  <symbol id="check-4" viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </symbol>
                </svg>
              </div>
              <div class="checkbox-wrapper-4">
                <input class="inp-cbx" id="domiciliochkbox" type="checkbox" formControlName="domicilioSeleccionado" (click)="imprimirEstadoCheckboxes('domicilioSeleccionado')">
                <label class="cbx" for="domiciliochkbox"><span>
                <svg width="12px" height="10px">

                </svg></span><span>Domicilio</span></label>
                <svg class="inline-svg">
                  <symbol id="check-4" viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </symbol>
                </svg>
              </div>
            </div>

            <div class="gw-flex-r">
                <label class="lbl-text">Colonia</label>
                <div class="select">
                    <select id="pais" formControlName="selectColonia"
                        [ngClass]="{validacion: (Des.selectColonia.invalid || Des.selectColonia.hasError('isEmpty')) && submitted}"
                        required (change)="coloniaChanged($event.target.value)">
                        <option value="" disabled selected class="option s">Seleccione</option>
                        <option *ngFor="let i of colonia" [value]="i.idcol">
                            {{ i.colonia }}
                        </option>
                    </select>
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Des.selectColonia.invalid)  && submitted}">* Introduce la colonia
                </div>
            </div>
        </div>

        <div class="div-form">
            <label class="lbl-text">Direccíon</label>
            <input formControlName="direccion" type="text" inputmode="text" autocomplete="street-address" maxlength="200"
                [ngClass]="{validacion: (Des.direccion.invalid || Des.direccion.hasError('IsEmpty')) && submitted}">
            <div class="val-valido" [ngClass]="{invalido: (Des.direccion.invalid)  && submitted}">* Introduce la direccion
            </div>
        </div>
        <div class="gw-flex">
            <div class="gw-flex-l">
                <label class="lbl-text">Teléfono</label>
                <input formControlName="telefono" (keydown)="cambiarFocus($event)" maxlength="10" minlength="10" type="text" inputmode="tel" autocomplete="tel"
                    [ngClass]="{validacion: (Des.telefono.invalid || Des.telefono.hasError('IsEmpty')) && submitted}" >
                <div class="val-valido" [ngClass]="{invalido: (Des.telefono.invalid && Des.telefono.value == '')  && submitted}">* Intenta con un teléfono valido
                </div>
                <div class="val-valido" [ngClass]="{invalido: (Des.telefono.value != '' && Des.telefono.invalid)  && submitted}">* Solo puedes ingresar 10 dígitos
                </div>
            </div>

            <div class="gw-flex-r">
                <label class="lbl-text">Código postal</label>
                <input type="text" formControlName="cp"
                    [ngClass]="{validacion: (Des.cp.value == null || Des.cp.invalid || Des.cp.hasError('IsEmpty')) && submitted}">
            </div>
        </div>

        <div class="gw-reverse-btn">
          <button name="Aceptar" class="gw-btn-continuar gw-btn-pasos" type="submit"
              (click)="guardarsesion_paso3()">{{ destinatarioForm.get('guardarDestinatario')?.value ? 'Guardar y continuar' : 'Continuar' }}</button>
          <button class="btn-back gw-btn-pasos"  type="button"  (click)="regresarMenu()">Regresar</button>
      </div>
    </form>
</div>

<!-- MODAL DIRECTORIO DESTINATARIO -->
<div class="gw-modal-overlay" *ngIf="showModalDirectorioDest" (click)="cerrarModalDirectorioDest()">
    <div class="gw-modal-content" (click)="$event.stopPropagation()">
        <div class="gw-modal-header">
            <div class="header-titles">
                <h3>Directorio de Destinatarios</h3>
                <p>Selecciona el destinatario que desea capturar</p>
            </div>
            <button class="gw-close-modal" (click)="cerrarModalDirectorioDest()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <div class="gw-modal-body">
            <!-- CONTROLES DIRECTORIO -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; gap: 15px;">
                <!-- BUSCADOR -->
                <div class="gw-search-container" style="margin-bottom: 0; flex: 1;">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text" [(ngModel)]="searchTermDest" (input)="filtrarDestinatarios()"
                        placeholder="Buscar destinatario...">
                </div>
            </div>

            <!-- Desktop View: Table -->
            <div class="gw-desktop-view">
                <table class="gw-remitente-table">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Estado</th>
                            <th>Ciudad</th>
                            <th>Dirección</th>
                            <th>Teléfono</th>
                            <th style="width: 90px; text-align: center;">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let dest of listaDestinatariosFiltrada" (click)="seleccionarDestinatario(dest)">
                            <td>{{dest.nombre}}</td>
                            <td>{{dest.estadoNombre}}</td>
                            <td>{{dest.ciudadNombre}}</td>
                            <td>{{ (dest.direccion && dest.direccion.toUpperCase() === 'OCURRE') || !dest.coloniaNombre || dest.coloniaNombre === '' || dest.coloniaNombre.toUpperCase() === 'OCURRE' ? dest.direccion : (dest.direccion + ', Col. ' + dest.coloniaNombre) }}</td>
                            <td>{{dest.tel}}</td>
                            <td class="td-action-buttons">
                                <button type="button" class="btn-action-table edit" (click)="editarDestinatario(dest, $event)" title="Editar">
                                    <i class="fa-solid fa-pen"></i>
                                </button>
                                <button type="button" class="btn-action-table delete" (click)="eliminarDestinatario(dest, $event)" title="Eliminar">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Mobile View: Cards -->
            <div class="gw-mobile-view">
                <div class="gw-remitente-grid">
                    <div class="gw-remitente-card" *ngFor="let dest of listaDestinatariosFiltrada"
                        (click)="seleccionarDestinatario(dest)">
                        <div class="card-selection-indicator">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div class="card-icon">
                            <i class="fa-solid fa-user"></i>
                        </div>
                        <div class="card-info">
                            <h4 class="rem-nombre">{{dest.nombre}}</h4>
                            <p class="rem-detalle"><i class="fa-solid fa-location-dot"></i> {{ (dest.direccion && dest.direccion.toUpperCase() === 'OCURRE') || !dest.coloniaNombre || dest.coloniaNombre === '' || dest.coloniaNombre.toUpperCase() === 'OCURRE' ? dest.direccion : (dest.direccion + ', Col. ' + dest.coloniaNombre) }}</p>
                            <p class="rem-detalle"><i class="fa-solid fa-city"></i> {{dest.ciudadNombre}}, {{dest.estadoNombre}}</p>
                            <p class="rem-detalle"><i class="fa-solid fa-phone"></i> {{dest.tel}}</p>
                            <div class="card-actions-row">
                                <button type="button" class="btn-action-card edit" (click)="editarDestinatario(dest, $event)">
                                    <i class="fa-solid fa-pen"></i> Editar
                                </button>
                                <button type="button" class="btn-action-card delete" (click)="eliminarDestinatario(dest, $event)">
                                    <i class="fa-solid fa-trash"></i> Eliminar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
